import * as React from 'react';
import { BinaryLabelModel } from './BinaryLabelModel';
import { BinaryLabelWidget } from './BinaryLabelWidget';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
export class BinaryLabelFactory extends AbstractReactFactory {
  constructor() {
    super('binary');
  }

  generateReactWidget(event) {
    return /*#__PURE__*/React.createElement(BinaryLabelWidget, {
      model: event.model,
      engine: this.engine
    });
  }

  generateModel(event) {
    return new BinaryLabelModel();
  }

}